/**
 * Shared field rule sets for application form validation.
 *
 * Each form picks the fields it needs from this object.
 * If a form requires different rules for a specific field,
 * it can override by spreading: { ...fieldRules.Phone, maxLength: maxLength(20) }
 */
import {
  required,
  requiredIf,
  email,
  maxLength,
} from '@vuelidate/validators';

import {
  filled,
  noNumbersAllowed,
  ssn,
  phone,
  sameAsEmail,
  applicationUniqueSsn,
  requiredOr,
  numericOr,
  noDigitsOr,
  maxLengthOr,
  minLengthOr,
} from './validationCustomValidators';

export const fieldRules = {
  FirstName: {
    required,
    maxLength: maxLength(50),
    noNumbersAllowed,
  },
  LastName: {
    required,
    maxLength: maxLength(50),
    noNumbersAllowed,
  },
  Ssn: {
    required,
    ssn,
    applicationUniqueSsn,
  },
  AddedNewApplicant: {},
  Address: {
    required: requiredOr('usePrimaryApplicantAddress'),
    maxLength: maxLengthOr(250, 'usePrimaryApplicantAddress'),
  },
  PostalCode: {
    required: requiredOr('usePrimaryApplicantAddress'),
    numeric: numericOr('usePrimaryApplicantAddress'),
    maxLength: maxLengthOr(5, 'usePrimaryApplicantAddress'),
    minLength: minLengthOr(5, 'usePrimaryApplicantAddress'),
  },
  City: {
    required: requiredOr('usePrimaryApplicantAddress'),
    noDigits: noDigitsOr('usePrimaryApplicantAddress'),
    maxLength: maxLengthOr(80, 'usePrimaryApplicantAddress'),
  },
  usePrimaryApplicantAddress: {},
  Phone: {
    required,
    phone,
    maxLength: maxLength(50),
  },
  PhoneCountryCode: {
    required,
    requiredIfPhone: requiredIf(({ Phone }) => {
      return filled(Phone);
    }),
  },
  ContactLanguage: {
    required,
  },
  Email: {
    required,
    email,
    maxLength: maxLength(100),
  },
  emailAgain: {
    required,
    email,
    maxLength: maxLength(100),
    sameAs: sameAsEmail,
  },
  MarketingAllowed: {},
};
